import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedActionsSortFilter(props) {
  const config = useThemeConfig();
  const ThemedActionsSortFilter = config.components.ActionsSortFilter;

  return <ThemedActionsSortFilter {...props} />;
}
